/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedInstellingenRouteImport } from './routes/_authenticated/instellingen'
import { Route as AuthenticatedKennisbankRouteImport } from './routes/_authenticated/kennisbank'
import { Route as AuthenticatedKlantenRouteImport } from './routes/_authenticated/klanten'
import { Route as AuthenticatedOverzichtRouteImport } from './routes/_authenticated/overzicht'
import { Route as AuthenticatedPartnersRouteImport } from './routes/_authenticated/partners'
import { Route as publicAanmeldenEnrollCodeRouteRouteImport } from './routes/(public)/aanmelden/$enrollCode/route'
import { Route as publicInloggenIndexRouteImport } from './routes/(public)/inloggen/index'
import { Route as publicInloggenBevestigenRouteImport } from './routes/(public)/inloggen/bevestigen'
import { Route as publicAanmeldenEnrollCodeIndexRouteImport } from './routes/(public)/aanmelden/$enrollCode/index'
import { Route as publicAanmeldenEnrollCodeGegevensRouteImport } from './routes/(public)/aanmelden/$enrollCode/gegevens'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInstellingenRoute =
  AuthenticatedInstellingenRouteImport.update({
    id: '/instellingen',
    path: '/instellingen',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedKennisbankRoute = AuthenticatedKennisbankRouteImport.update({
  id: '/kennisbank',
  path: '/kennisbank',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedKlantenRoute = AuthenticatedKlantenRouteImport.update({
  id: '/klanten',
  path: '/klanten',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOverzichtRoute = AuthenticatedOverzichtRouteImport.update({
  id: '/overzicht',
  path: '/overzicht',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPartnersRoute = AuthenticatedPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const publicAanmeldenEnrollCodeRouteRoute =
  publicAanmeldenEnrollCodeRouteRouteImport.update({
    id: '/(public)/aanmelden/$enrollCode',
    path: '/aanmelden/$enrollCode',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicInloggenIndexRoute = publicInloggenIndexRouteImport.update({
  id: '/(public)/inloggen/',
  path: '/inloggen/',
  getParentRoute: () => rootRouteImport,
} as any)
const publicInloggenBevestigenRoute =
  publicInloggenBevestigenRouteImport.update({
    id: '/(public)/inloggen/bevestigen',
    path: '/inloggen/bevestigen',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicAanmeldenEnrollCodeIndexRoute =
  publicAanmeldenEnrollCodeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => publicAanmeldenEnrollCodeRouteRoute,
  } as any)
const publicAanmeldenEnrollCodeGegevensRoute =
  publicAanmeldenEnrollCodeGegevensRouteImport.update({
    id: '/gegevens',
    path: '/gegevens',
    getParentRoute: () => publicAanmeldenEnrollCodeRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/instellingen': typeof AuthenticatedInstellingenRoute
  '/kennisbank': typeof AuthenticatedKennisbankRoute
  '/klanten': typeof AuthenticatedKlantenRoute
  '/overzicht': typeof AuthenticatedOverzichtRoute
  '/partners': typeof AuthenticatedPartnersRoute
  '/aanmelden/$enrollCode': typeof publicAanmeldenEnrollCodeRouteRouteWithChildren
  '/inloggen/bevestigen': typeof publicInloggenBevestigenRoute
  '/inloggen/': typeof publicInloggenIndexRoute
  '/aanmelden/$enrollCode/gegevens': typeof publicAanmeldenEnrollCodeGegevensRoute
  '/aanmelden/$enrollCode/': typeof publicAanmeldenEnrollCodeIndexRoute
}
export interface FileRoutesByTo {
  '/instellingen': typeof AuthenticatedInstellingenRoute
  '/kennisbank': typeof AuthenticatedKennisbankRoute
  '/klanten': typeof AuthenticatedKlantenRoute
  '/overzicht': typeof AuthenticatedOverzichtRoute
  '/partners': typeof AuthenticatedPartnersRoute
  '/': typeof AuthenticatedIndexRoute
  '/inloggen/bevestigen': typeof publicInloggenBevestigenRoute
  '/inloggen': typeof publicInloggenIndexRoute
  '/aanmelden/$enrollCode/gegevens': typeof publicAanmeldenEnrollCodeGegevensRoute
  '/aanmelden/$enrollCode': typeof publicAanmeldenEnrollCodeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/instellingen': typeof AuthenticatedInstellingenRoute
  '/_authenticated/kennisbank': typeof AuthenticatedKennisbankRoute
  '/_authenticated/klanten': typeof AuthenticatedKlantenRoute
  '/_authenticated/overzicht': typeof AuthenticatedOverzichtRoute
  '/_authenticated/partners': typeof AuthenticatedPartnersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/(public)/aanmelden/$enrollCode': typeof publicAanmeldenEnrollCodeRouteRouteWithChildren
  '/(public)/inloggen/bevestigen': typeof publicInloggenBevestigenRoute
  '/(public)/inloggen/': typeof publicInloggenIndexRoute
  '/(public)/aanmelden/$enrollCode/gegevens': typeof publicAanmeldenEnrollCodeGegevensRoute
  '/(public)/aanmelden/$enrollCode/': typeof publicAanmeldenEnrollCodeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/instellingen'
    | '/kennisbank'
    | '/klanten'
    | '/overzicht'
    | '/partners'
    | '/aanmelden/$enrollCode'
    | '/inloggen/bevestigen'
    | '/inloggen/'
    | '/aanmelden/$enrollCode/gegevens'
    | '/aanmelden/$enrollCode/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/instellingen'
    | '/kennisbank'
    | '/klanten'
    | '/overzicht'
    | '/partners'
    | '/'
    | '/inloggen/bevestigen'
    | '/inloggen'
    | '/aanmelden/$enrollCode/gegevens'
    | '/aanmelden/$enrollCode'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/instellingen'
    | '/_authenticated/kennisbank'
    | '/_authenticated/klanten'
    | '/_authenticated/overzicht'
    | '/_authenticated/partners'
    | '/_authenticated/'
    | '/(public)/aanmelden/$enrollCode'
    | '/(public)/inloggen/bevestigen'
    | '/(public)/inloggen/'
    | '/(public)/aanmelden/$enrollCode/gegevens'
    | '/(public)/aanmelden/$enrollCode/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  publicAanmeldenEnrollCodeRouteRoute: typeof publicAanmeldenEnrollCodeRouteRouteWithChildren
  publicInloggenBevestigenRoute: typeof publicInloggenBevestigenRoute
  publicInloggenIndexRoute: typeof publicInloggenIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instellingen': {
      id: '/_authenticated/instellingen'
      path: '/instellingen'
      fullPath: '/instellingen'
      preLoaderRoute: typeof AuthenticatedInstellingenRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kennisbank': {
      id: '/_authenticated/kennisbank'
      path: '/kennisbank'
      fullPath: '/kennisbank'
      preLoaderRoute: typeof AuthenticatedKennisbankRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/klanten': {
      id: '/_authenticated/klanten'
      path: '/klanten'
      fullPath: '/klanten'
      preLoaderRoute: typeof AuthenticatedKlantenRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/overzicht': {
      id: '/_authenticated/overzicht'
      path: '/overzicht'
      fullPath: '/overzicht'
      preLoaderRoute: typeof AuthenticatedOverzichtRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/partners': {
      id: '/_authenticated/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof AuthenticatedPartnersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(public)/aanmelden/$enrollCode': {
      id: '/(public)/aanmelden/$enrollCode'
      path: '/aanmelden/$enrollCode'
      fullPath: '/aanmelden/$enrollCode'
      preLoaderRoute: typeof publicAanmeldenEnrollCodeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/inloggen/': {
      id: '/(public)/inloggen/'
      path: '/inloggen'
      fullPath: '/inloggen/'
      preLoaderRoute: typeof publicInloggenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/inloggen/bevestigen': {
      id: '/(public)/inloggen/bevestigen'
      path: '/inloggen/bevestigen'
      fullPath: '/inloggen/bevestigen'
      preLoaderRoute: typeof publicInloggenBevestigenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/aanmelden/$enrollCode/': {
      id: '/(public)/aanmelden/$enrollCode/'
      path: '/'
      fullPath: '/aanmelden/$enrollCode/'
      preLoaderRoute: typeof publicAanmeldenEnrollCodeIndexRouteImport
      parentRoute: typeof publicAanmeldenEnrollCodeRouteRoute
    }
    '/(public)/aanmelden/$enrollCode/gegevens': {
      id: '/(public)/aanmelden/$enrollCode/gegevens'
      path: '/gegevens'
      fullPath: '/aanmelden/$enrollCode/gegevens'
      preLoaderRoute: typeof publicAanmeldenEnrollCodeGegevensRouteImport
      parentRoute: typeof publicAanmeldenEnrollCodeRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedInstellingenRoute: typeof AuthenticatedInstellingenRoute
  AuthenticatedKennisbankRoute: typeof AuthenticatedKennisbankRoute
  AuthenticatedKlantenRoute: typeof AuthenticatedKlantenRoute
  AuthenticatedOverzichtRoute: typeof AuthenticatedOverzichtRoute
  AuthenticatedPartnersRoute: typeof AuthenticatedPartnersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedInstellingenRoute: AuthenticatedInstellingenRoute,
  AuthenticatedKennisbankRoute: AuthenticatedKennisbankRoute,
  AuthenticatedKlantenRoute: AuthenticatedKlantenRoute,
  AuthenticatedOverzichtRoute: AuthenticatedOverzichtRoute,
  AuthenticatedPartnersRoute: AuthenticatedPartnersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface publicAanmeldenEnrollCodeRouteRouteChildren {
  publicAanmeldenEnrollCodeGegevensRoute: typeof publicAanmeldenEnrollCodeGegevensRoute
  publicAanmeldenEnrollCodeIndexRoute: typeof publicAanmeldenEnrollCodeIndexRoute
}

const publicAanmeldenEnrollCodeRouteRouteChildren: publicAanmeldenEnrollCodeRouteRouteChildren =
  {
    publicAanmeldenEnrollCodeGegevensRoute:
      publicAanmeldenEnrollCodeGegevensRoute,
    publicAanmeldenEnrollCodeIndexRoute: publicAanmeldenEnrollCodeIndexRoute,
  }

const publicAanmeldenEnrollCodeRouteRouteWithChildren =
  publicAanmeldenEnrollCodeRouteRoute._addFileChildren(
    publicAanmeldenEnrollCodeRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  publicAanmeldenEnrollCodeRouteRoute:
    publicAanmeldenEnrollCodeRouteRouteWithChildren,
  publicInloggenBevestigenRoute: publicInloggenBevestigenRoute,
  publicInloggenIndexRoute: publicInloggenIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
